// mds-dojo — dijit/hccss — FAITHFUL port of references/dijit/hccss.js.
// On DOM ready, adds the `dijit_a11y` class to <body> when high-contrast mode is
// detected, and re-exports the `has` feature-tester (ColorPalette reads
// has("highcontrast") through this module).
//
// FAITHFUL-ADAPTATION (flagged): the real module depends on `dojo/hccss`, whose
// media-query/background-image probe SETS has("highcontrast"). That probe module is
// not ported here, so `has("highcontrast")` is always falsy on evergreen browsers —
// i.e. the `dijit_a11y` class is never added and ColorPalette always uses its normal
// (non-high-contrast) swatch template. This matches dojo's behavior on every machine
// NOT in forced high-contrast mode.
//  - `dojo/domReady` → `../dojo/ready`; `dojo/hccss` → `../dojo/has`;
//    `dojo/_base/window` → `../dojo/_base/window`.
import domClass from '../dojo/dom-class';
import has from '../dojo/has';
import ready from '../dojo/ready';
import win from '../dojo/_base/window';

ready(function () {
	if (has("highcontrast")) {
		domClass.add(win.body(), "dijit_a11y");
	}
});

export default has;
